"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utils = require("../lib/utils");

var _smallMessage = _interopRequireDefault(require("./smallMessage"));

var _regularMessage = _interopRequireDefault(require("./regularMessage"));

require("./messageBox.css");

var _excluded = ["size", "dataTestId"];

var MessageBox = function MessageBox(_ref) {
  var size = _ref.size,
      dataTestId = _ref.dataTestId,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": dataTestId,
    className: (0, _utils.gatherClasses)(props, "oui-message-box")
  }, size === "sm" ? /*#__PURE__*/_react["default"].createElement(_smallMessage["default"], props) : /*#__PURE__*/_react["default"].createElement(_regularMessage["default"], (0, _extends2["default"])({
    size: size
  }, props)));
};

MessageBox.defaultProps = {
  size: "md",
  dataTestId: "orion-message-box"
};
MessageBox.propTypes = {
  size: _propTypes["default"].string,
  dataTestId: _propTypes["default"].string
};
MessageBox.displayName = "OrionMessageBox";
var _default = MessageBox;
exports["default"] = _default;